import type { TooltipItemPositionGetter } from '@mui/x-charts/internals';

const tooltipItemPositionGetter: TooltipItemPositionGetter<'radialBar'> = () => {
  // Todo: to implement
  return null;
};

export default tooltipItemPositionGetter;
